function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.5684 10.449L15.7656 14.6328C15.8379 14.7053 15.8936 14.7885 15.9326 14.8772C16.0615 15.1704 16.0049 15.5251 15.7646 15.7656C15.6074 15.9221 15.4014 16 15.1953 16C14.9902 16 14.7842 15.9221 14.627 15.7656L10.4238 11.5753C9.33008 12.415 7.96484 12.9205 6.48047 12.9205C2.90723 12.9205 0 10.0223 0 6.46021C0 2.89819 2.90723 0 6.48047 0C10.0537 0 12.9609 2.89819 12.9609 6.46021C12.9609 7.9657 12.4375 9.34924 11.5684 10.449ZM6.48145 1.60254C3.79492 1.60254 1.6084 3.78186 1.6084 6.46033C1.6084 9.13867 3.79492 11.318 6.48145 11.318C9.16797 11.318 11.3545 9.13867 11.3545 6.46033C11.3545 3.78186 9.16797 1.60254 6.48145 1.60254Z",
  fill: "#6B6C7E"
});

var SvgSearchIcon = function SvgSearchIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/searchIcon.d30851b6.svg";
export { ForwardRef as ReactComponent };